module.exports = __webpack_public_path__ + "static/media/mac-step2.770811b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mac-step2.png
// module id = 599
// module chunks = 33